import azkarData from '../data/azkar.json';
import morningData from '../data/sets/morning.json';
import eveningData from '../data/sets/evening.json';
import salawatData from '../data/salawat.json';
import {
  azkarFileSchema,
  setManifestSchema,
  salawatFileSchema,
  type SalawatText,
} from './schema.js';
import type { ResolvedSet, ZikrSetId } from './types.js';

export * from './types.js';
export * from './schema.js';

/**
 * Схема прогоняется на билде через `pnpm validate:content`, поэтому здесь
 * парсим без повторной валидации в рантайме — но типы берём от схемы,
 * чтобы расхождение JSON и типов ловилось компилятором.
 */
const azkarFile = azkarFileSchema.parse(azkarData);
const manifests = [morningData, eveningData].map((m) =>
  setManifestSchema.parse(m),
);

const byId = new Map(azkarFile.azkar.map((z) => [z.id, z]));

function resolve(manifest: (typeof manifests)[number]): ResolvedSet {
  return {
    id: manifest.id,
    titleRu: manifest.titleRu,
    subtitleRu: manifest.subtitleRu,
    items: manifest.items.map((item) => {
      const zikr = byId.get(item.zikrId);
      if (!zikr) {
        throw new Error(
          `Манифест "${manifest.id}" ссылается на неизвестный zikrId "${item.zikrId}"`,
        );
      }
      return { ...zikr, repeat: item.repeat ?? zikr.repeat };
    }),
  };
}

const sets: Record<ZikrSetId, ResolvedSet> = {
  morning: resolve(manifests.find((m) => m.id === 'morning')!),
  evening: resolve(manifests.find((m) => m.id === 'evening')!),
};

export function getSet(id: ZikrSetId): ResolvedSet {
  return sets[id];
}

export function getAllSets(): ResolvedSet[] {
  return [sets.morning, sets.evening];
}

/** Контент ещё не выверен — UI показывает предупреждение */
export const isContentUnverified = azkarFile.unverified === true;

const salawatFile = salawatFileSchema.parse(salawatData);

/**
 * null означает, что текст ещё не предоставлен владельцем репозитория.
 * Счётчик салавата в этом случае работает, но текст не показывает —
 * придумывать арабский нельзя.
 */
export function getSalawat(): SalawatText | null {
  return salawatFile.text;
}
